import React from 'react';
import { OAuthProviderType } from 'nekst-api';

interface SettingsSuccessStatusProps {
  provider?: OAuthProviderType | null;
}

export default function SettingsSuccessStatus({ provider }: SettingsSuccessStatusProps) {
  const getProviderName = () => {
    switch (provider) {
      case OAuthProviderType.GOOGLE:
        return 'Google';
      case OAuthProviderType.APPLE:
        return 'Apple';
      default:
        return 'OAuth';
    }
  };

  return (
    <div>
      <i
        className="fa fa-check-circle"
        style={{ fontSize: '2rem', marginBottom: '1rem', color: '#28a745' }}
      />
      <h2 style={{ marginBottom: '1rem', color: '#28a745' }}>
        {getProviderName()} account connected successfully!
      </h2>
      <p style={{ color: '#666' }}>
        Your {getProviderName()} account is now linked to your profile. You're being redirected back to settings...
      </p>
    </div>
  );
}